<template>
  <div class="text-static-default-hi body-2-bold mb-28 md:mb-32">
    <div class="flex flex-col gap-8">
      <ItemObsoleteComputer v-if="showObsoleteDevices" />
      <ItemShipping :shipping />
      <ItemCarrier
        :carrier
        :tracking="{
          zone: 'carrier_compatibility',
          name: 'carrier_info',
        }"
      />
      <ItemReassurance :tracking :warranty-delay />
      <ItemVerifiedRefurbished v-if="showVerifiedRefurbished" />
      <ExpressReplacement v-if="showExpressReplacement" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import type { GetPickersResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/pickers'
import type { GetProductResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/product'

import ExpressReplacement from './components/ExpressReplacement/ExpressReplacement.vue'
import ItemCarrier from './components/ItemCarrier/ItemCarrier.vue'
import ItemObsoleteComputer from './components/ItemObsoleteComputer/ItemObsoleteComputer.vue'
import ItemReassurance from './components/ItemReassurance/ItemReassurance.vue'
import ItemShipping from './components/ItemShipping/ItemShipping.vue'
import ItemVerifiedRefurbished from './components/ItemVerifiedRefurbished/ItemVerifiedRefurbished.vue'

withDefaults(
  defineProps<{
    carrier: GetProductResponse['carrier']
    shipping: NonNullable<GetPickersResponse['selectedOffer']>['shipping']
    warrantyDelay?: string | null
    showVerifiedRefurbished?: GetProductResponse['showVerifiedRefurbished']
    showObsoleteDevices?: GetProductResponse['showObsoleteDevices']
    showExpressReplacement?: boolean
  }>(),
  {
    warrantyDelay: undefined,
    showVerifiedRefurbished: false,
    showObsoleteDevices: false,
    showExpressReplacement: false,
  },
)

const tracking = computed(() => {
  return { zone: 'return_info', name: '30_days_return' }
})
</script>
